import { CalendarDays, CheckCircle2, Cpu, MapPin, Network, ArrowRight } from "lucide-react";

const factIcons = [CalendarDays, MapPin, Network, Cpu];

export function CompanySnapshot({ content, brand, images = [] }) {
  const chainLabels = [content.facts?.[3]?.label, content.facts?.[1]?.value, content.facts?.[2]?.label].filter(Boolean);

  return (
    <>
      <section id="overview" className="section snapshot-section" data-testid="company-snapshot-section">
        <div className="snapshot-layout slide-split">
          <div className="section-heading snapshot-heading">
            <p className="overline" data-testid="snapshot-overline">{content.overline}</p>
            <h2 data-testid="snapshot-title">{content.title}</h2>
            <p data-testid="snapshot-description">{content.description}</p>
          </div>

          <div className="deck-image-panel strength-panel" data-testid="snapshot-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="snapshot-image-1" /> : (
              <div className="technical-panel-content" data-testid="snapshot-strength-panel-content">
                <span>{brand}</span>
                <strong>{content.facts?.[3]?.value}</strong>
                <p>{content.facts?.[2]?.value}</p>
              </div>
            )}
          </div>
        </div>

        <div className="snapshot-facts" data-testid="snapshot-facts">
          {content.facts.map((fact, index) => (
            <article className="snapshot-fact" key={fact.label} data-testid={`snapshot-fact-${index + 1}`}>
              <div className="snapshot-fact-icon" data-testid={`snapshot-fact-icon-${index + 1}`}>
                {(() => {
                  const Icon = factIcons[index] || Cpu;
                  return <Icon size={23} aria-hidden="true" />;
                })()}
              </div>
              <span data-testid={`snapshot-fact-label-${index + 1}`}>{fact.label}</span>
              <strong data-testid={`snapshot-fact-value-${index + 1}`}>{fact.value}</strong>
            </article>
          ))}
        </div>
      </section>

      <section className="section snapshot-chain-section" data-testid="snapshot-chain-section">
        <div className="slide-split">
          <div className="section-heading">
            <p className="overline" data-testid="snapshot-chain-overline">{content.overline}</p>
            <h2 data-testid="snapshot-chain-title">{brand}</h2>
          </div>
          <div className="deck-image-panel" data-testid="snapshot-image-panel-2">
            {images[1]?.image ? <img src={images[1].image} alt={brand} data-testid="snapshot-image-2" /> : <span>{content.facts?.[2]?.value}</span>}
          </div>
        </div>
        <div className="snapshot-value-chain" data-testid="snapshot-value-chain">
          <div className="snapshot-chain-node" data-testid="snapshot-chain-suppliers">{chainLabels[0]}</div>
          <ArrowRight size={18} aria-hidden="true" />
          <div className="snapshot-chain-node focus" data-testid="snapshot-chain-hi-power">{brand || chainLabels[1]}</div>
          <ArrowRight size={18} aria-hidden="true" />
          <div className="snapshot-chain-node" data-testid="snapshot-chain-customers">{chainLabels[2]}</div>
        </div>
        <div className="strength-proof-row" data-testid="snapshot-strength-proof-row">
          {content.facts.slice(0, 3).map((fact, index) => (
            <div className="strength-proof-item" key={fact.label} data-testid={`snapshot-proof-item-${index + 1}`}>
              <CheckCircle2 size={16} aria-hidden="true" />
              <span>{fact.label}</span>
              <strong>{fact.value}</strong>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}